export enum Role {
    SiteAdmin = "SITE_ADMIN",
    Reseller = "RESELLER_ADMIN",
    BusinessAdmin = "BUSINESS_ADMIN",
    UserBusiness = "BUSINESS_USER",
    None = ""
}
